import React from 'react';
import { useFindEntities } from './useFindEntities';
import { Entities } from '../const';
export var useNewLineEntities = function (readOnly) {
    var NewLineEntity = function () {
        return React.createElement(React.Fragment, null, readOnly ? '\u000A' : React.createElement(React.Fragment, null,
            '\u21b5',
            React.createElement("br", null)));
    };
    var findNewLineEntities = function (contentBlock, callback, contentState) {
        var findEntities = useFindEntities(Entities.NEW_LINE).findEntities;
        findEntities(contentBlock, callback, contentState);
    };
    return { NewLineEntity: NewLineEntity, findNewLineEntities: findNewLineEntities };
};
